import { useEffect, useState } from "react";

// Iconen via inline SVG zodat we niet afhankelijk zijn van een icon-font.
const Icons = {
  map: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="3 6 9 3 15 6 21 3 21 18 15 21 9 18 3 21" />
      <line x1="9" y1="3" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="21" />
    </svg>
  ),
  list: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" />
      <circle cx="3.5" cy="6" r="1" /><circle cx="3.5" cy="12" r="1" /><circle cx="3.5" cy="18" r="1" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
    </svg>
  ),
  sliders: (
    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="4" y1="21" x2="4" y2="14" /><line x1="4" y1="10" x2="4" y2="3" />
      <line x1="12" y1="21" x2="12" y2="12" /><line x1="12" y1="8" x2="12" y2="3" />
      <line x1="20" y1="21" x2="20" y2="16" /><line x1="20" y1="12" x2="20" y2="3" />
      <line x1="1" y1="14" x2="7" y2="14" /><line x1="9" y1="8" x2="15" y2="8" /><line x1="17" y1="16" x2="23" y2="16" />
    </svg>
  ),
};

// Probeer een DOM-element te klikken via meerdere kandidaat-selectors.
// Geeft true terug als een element gevonden + geklikt is.
function clickAny(selectors) {
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el) { el.click(); return true; }
  }
  return false;
}

// Bepaal welk tabblad als 'actief' moet worden gemarkeerd.
function deriveActiveTab() {
  // Open modal (town/listing) → de actieve tab volgens onze logica is de bron
  if (document.querySelector(".modal.modal-open, .town-modal, .listing-modal")) {
    // Default naar 'map' want modals worden meestal vanaf de map geopend.
    return "map";
  }
  if (document.querySelector(".sidebar-left.open"))  return "filter";
  if (document.querySelector(".sidebar-right.open")) return "list";
  return "map";
}

export function BottomNav() {
  const [active, setActive] = useState("map");
  const [hasFavs, setHasFavs] = useState(false);

  // Sync active state met DOM (drawers openen/sluiten via TopBar of swipe)
  useEffect(() => {
    let raf = 0;
    const tick = () => {
      const a = deriveActiveTab();
      setActive(prev => prev === a ? prev : a);
      raf = window.requestAnimationFrame(tick);
    };
    raf = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(raf);
  }, []);

  // Detect of er favorieten zijn — voor het kleine puntje op de star-tab
  useEffect(() => {
    const check = () => {
      try {
        const raw = localStorage.getItem("portugal.workflow") || localStorage.getItem("workflow_state");
        if (!raw) return setHasFavs(false);
        const obj = JSON.parse(raw);
        const any = Object.values(obj || {}).some(v => v && v.is_favorite);
        setHasFavs(any);
      } catch { setHasFavs(false); }
    };
    check();
    const id = setInterval(check, 3000);
    return () => clearInterval(id);
  }, []);

  const goMap = () => {
    // Sluit beide drawers + eventuele modals
    clickAny([".sidebar-left.open .topbar-close", ".sidebar-right.open .topbar-close"]);
    // Sluit modal: trigger history.back als er een modal openstaat
    if (document.querySelector(".modal.modal-open, .town-modal, .listing-modal")) {
      history.back();
    } else {
      // Reset scrim
      document.querySelector(".scrim")?.click();
    }
    setActive("map");
  };

  const goFilter = () => {
    // Open de criteria-sidebar links via de bestaande TopBar-knop
    clickAny([".topbar-btn-criteria", ".topbar-criteria", "[data-pwa-open='criteria']"]);
    setActive("filter");
  };

  const goList = () => {
    // Open ranking-sidebar rechts
    clickAny([".topbar-btn-ranking", ".topbar-ranking", "[data-pwa-open='ranking']"]);
    setActive("list");
  };

  const goFavorites = () => {
    // Open ranking + dispatch event zodat een toekomstige filter mee kan luisteren
    clickAny([".topbar-btn-ranking", ".topbar-ranking", "[data-pwa-open='ranking']"]);
    window.dispatchEvent(new CustomEvent("pwa:show-favorites"));
    setActive("favorites");
  };

  return (
    <nav className="pwa-bottom-nav" role="navigation" aria-label="Hoofdnavigatie">
      <button className={`bn-tab ${active === "map" ? "active" : ""}`} onClick={goMap} aria-label="Kaart">
        {Icons.map}<span>Kaart</span>
      </button>
      <button className={`bn-tab ${active === "list" ? "active" : ""}`} onClick={goList} aria-label="Lijst">
        {Icons.list}<span>Lijst</span>
      </button>
      <button className={`bn-tab ${active === "favorites" ? "active" : ""}`} onClick={goFavorites} aria-label="Favorieten">
        <span className="bn-icon-wrap">
          {Icons.star}{hasFavs && <span className="bn-dot" />}
        </span><span>Favorieten</span>
      </button>
      <button className={`bn-tab ${active === "filter" ? "active" : ""}`} onClick={goFilter} aria-label="Filter">
        {Icons.sliders}<span>Filter</span>
      </button>
    </nav>
  );
}
